import { Button, Form, Input, Modal, Rate, Table, message } from "antd";
import { TypeName, layoutForms } from "../../../component/utility";
/////Redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  OfflineCoreServices,
  CallCoreServicesActionWithToken,
} from "../../../appRedux/actions/CoreServicesAction";
import Url from "../../../apiCall/UrlConfig";
import { useEffect, useState } from "react";
import { ReactSketchCanvas } from "react-sketch-canvas";
import useWindowDimensions from "../../../component/getWindowDimensions";
const ImagePreAddress = Url.baseURL[0] + Url.downloadImage;
const ReportLabeling = (props) => {
  const [form] = Form.useForm();
  const [selectedRow, setSelectedRow] = useState(null);
  const [_showModalPreview, setshowModalPreview] = useState(false);
  const { height, width } = useWindowDimensions();
  const Columns = [
    { title: "کد", dataIndex: "id", key: "id" },
    { title: "شماره دندان", dataIndex: "numberTooth", key: "numberTooth" },
    { title: "نوع تشخیص", dataIndex: "typeDetail", key: "typeDetail" },
    {
      title: "Image",
      dataIndex: "Image",
      key: "Image",
      render: (obj, item, index) => {
        let imageSource = ImagePreAddress + item.patientImage.imageUrl;
        let base64Masked = item.base64Masked;
        return (
          <div onClick={() => _onClickedImageToShowPreview(item)}>
            <img
              key={obj}
              src={base64Masked}
              alt="jaw"
              style={{
                width: "70px",
                backgroundImage: "url(" + imageSource + ")",
                backgroundSize: "cover",
              }}
            />
            <img
              key={obj}
              src={imageSource}
              alt="jaw"
              style={{ width: "70px" }}
            />
          </div>
        );
      },
    },
    {
      title: "درجه کیفیت تشخیص",
      dataIndex: "rankedImage",
      key: "rankedImage",
      render: (obj, item, index) => {
        return (
          <>
            <Rate
              onChange={(e) => _onClickRanked(e, item)}
              defaultValue={obj}
            />
          </>
        );
      },
    },
  ];

  const _onClickedImageToShowPreview = (item) => {
    setSelectedRow(item);
    setshowModalPreview(true);
  };
  const _onClickRanked = async (value, item) => {
    let url = Url.SaveRanked;

    let res = await props.actions.CallCoreServicesActionWithToken(url, {
      IdImageDetail: item.id,
      rankedNumber: value,
    });

    console.log(res);
    if (res.hasError) {
      message.error(res.message);
      return;
    }
    message.success(res.message);
  };
  const _getReported = async (paging) => {
    let url = Url.GetLabeling;

    let res = await props.actions.CallCoreServicesActionWithToken(url, paging);

    console.log(res);
    if (res.hasError) {
      message.error(res.message);
      return;
    }
  };
  useEffect(() => {
    _getReported({ pageNumber: 1, pageSize: 1000 });
  }, []);
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <Modal
        open={_showModalPreview}
        onCancel={() => setshowModalPreview(false)}
        footer={null}
        width={width * 0.8}
      >
        <div>
          <div style={{ textAlign: "center", fontSize: 20 }}>
            {TypeName(selectedRow?.typeDetail)}
          </div>
          <div style={{ textAlign: "center", fontSize: 20 }}>
            دندان {selectedRow?.numberTooth}
          </div>
          <img
            key={selectedRow}
            src={selectedRow?.base64Masked}
            alt="jaw"
            style={{
              width: "50%",
              backgroundImage:
                "url(" +
                ImagePreAddress +
                selectedRow?.patientImage?.imageUrl +
                ")",
              backgroundSize: "cover",
            }}
          />
          <img
            key={selectedRow}
            src={ImagePreAddress + selectedRow?.patientImage?.imageUrl}
            alt="jaw"
            style={{ width: "50%" }}
          />
        </div>
      </Modal>
      <div style={{ alignSelf: "center", width: "80%" }}>
        <Table
          columns={Columns}
          dataSource={props.coreData[Url.GetLabeling]?.[Url.action]?.data}
          loading={props.coreData[Url.GetLabeling]?.[Url.action]?.isFetching}
          rowKey={(o) => o.id}
        />
      </div>
    </div>
  );
};

const actionCreators = Object.assign(
  {},
  { CallCoreServicesActionWithToken, OfflineCoreServices }
);
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = (state) => ({
  coreData: state.coreservices.coreData,
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportLabeling);
